import { httpClient } from '../../../Common/api/http_client';

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getAllLevels() {
  return httpClient.get('/merchant/loyalty-level');
}

/**
 *
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export function createALevel(payload) {
  return httpClient.post('/merchant/loyalty-level', payload);
}

/**
 *
 * @param levelId
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateLevel(levelId, payload) {
  return httpClient.put(`/merchant/loyalty-level/${levelId}`, payload);
}


/**
 *
 * @param levelId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteLevel(levelId) {
  return httpClient.delete(`/merchant/loyalty-level/${levelId}`);
}

/**
 *
 * @param page
 * @param limit
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getAllLoyaltyItems(page, limit) {
  return httpClient.get(`/merchant/loyalty-level-items?limit=${limit}&page=${page}`);
}

/**
 *
 * @param loyaltyId
 * @param page
 * @param limit
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getItemsByLoyalty(loyaltyId, page, limit) {
  return httpClient.get(`/merchant/loyalty-level/${loyaltyId}/item?limit=${limit}&page=${page}`);
}

/**
 *
 * @param loyaltyId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function createLoyaltyItems(loyaltyId, data) {
  return httpClient.post(`/merchant/loyalty-level/${loyaltyId}/item`, data);
}

/**
 *
 * @param loyaltyId
 * @param itemIds
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteLoyaltyLevelItem(loyaltyId, itemIds) {
  return httpClient.delete(`/merchant/loyalty-level/${loyaltyId}/items?ids=${itemIds}`);
}

/**
 *
 * @param limit
 * @param page
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getAllLoyaltyCustomers(page, limit) {
  return httpClient.get(`/merchant/loyalty-customer?limit=${limit}&page=${page}`);
}

/**
 *
 * @param loyaltyLevelId
 * @param limit
 * @param page
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getLoyaltyCustomersByLevel(loyaltyLevelId, page, limit) {
  return httpClient.get(`/merchant/loyalty-level/${loyaltyLevelId}/customer?limit=${limit}&page=${page}`);
}

/**
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function createLoyaltyCustomers(data) {
  return httpClient.post('/merchant/loyalty-customer/', data);
}

/**
 *
 * @param customerIds
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteLoyaltyCustomers(customerIds) {
  return httpClient.delete(`/merchant/loyalty-customer?ids=${customerIds}`);
}
